
import { Dialog } from "element-ui"
export default {
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    title: String,
    visible: {
      type: Boolean,
      default: false
    },
    handleSubmit: Function,
    handleClose: Function,
    cancelText: String,
    submitText: String
  },
  methods: {
    cancel() {
      this.handleClose()
    },
    submit() {
      if (typeof this.handleSubmit === "function") {
        this.handleSubmit()
      }
      this.handleClose()
    }
  }
}
